import { LOCATION_CHANGE, push } from 'connected-react-router';
import { pathToRegexp } from 'path-to-regexp';
import { startArchiveThread } from 'store/actions/threadsActions';
import { startArchiveCase, startUnarchiveCase } from 'store/actions/casesActions';
import React from 'react'
import { Redirect } from "react-router-dom";

const clientThreadPath = pathToRegexp('/:cid/clientThreads/:tid');
const caseChatPath = pathToRegexp('/caseChat/:cid');
const threadPath = pathToRegexp('/threads/:tid');
const threadPermissionsPath = pathToRegexp('/threadshare/:tid/:role');
const casePath = pathToRegexp('/case/:cid');
const casePermissionsPath = pathToRegexp('/caseshare/:cid/:role');
const archivedCases = pathToRegexp('/cases/archived');
const archivedCasesPath = pathToRegexp('/case/archived/:cid');
const cases = pathToRegexp('/cases');
const threads = pathToRegexp('/chat');
const explore = pathToRegexp('/explore');
const settings = pathToRegexp('/settings');
const profile = pathToRegexp('/profile');
const notifications = pathToRegexp('/notifications');
const setup = pathToRegexp('/setup');
const createFirm = pathToRegexp('/create-firm');
const calendar = pathToRegexp('/calendar');
const offers = pathToRegexp('/offers');
const viewLawyer = pathToRegexp('/lawyer/:id');

function permissionScreenName(role) {
  switch (role) {
    case 'lawyer':
      return 'Assign Lawyer';
    case 'client':
      return 'Assign Client';
    default:
      return 'Permissions';
  }
}

function parsePath(path) {
  let match = clientThreadPath.exec(path);
  if (path === '/') {
    return {
      screenName: 'Cases',
      showEditMenu: false,
      showNotifications: true,
      hideSidebar: false,
    }
  }
  if (match)
    return {
      cid: match[1],
      tid: match[2],
      screenName: 'Chat',
      goBackLink: `/caseChat/${match[1]}`,
      editPermissionsLink: `/threadshare/${match[2]}/collaborator`,
      archiveAction: startArchiveThread(match[2]),
      showEditMenu: true,
      showNotifications: false,
      hideSidebar: false,
    };
  match = viewLawyer.exec(path);
  if (match) {
    return {
      screenName: 'Profile View',
      goBackLink: `/explore`,
      showNotifications: true,
    }
  }
  match = threadPath.exec(path);
  if (match)
    return {
      tid: match[1],
      screenName: 'Chat',
      goBackLink: `/chat`,
      editPermissionsLink: `/threadshare/${match[1]}/collaborator`,
      archiveAction: startArchiveThread(match[1]),
      showEditMenu: true,
      showNotifications: false,
      hideSidebar: false,
    };
  match = threadPermissionsPath.exec(path);
  if (match)
    return {
      tid: match[1],
      screenName: 'Permissions',
      goBackLink: `/threads/${match[1]}`,
      showEditMenu: false,
      showNotifications: false,
      hideSidebar: false,
    };
  match = caseChatPath.exec(path);
  if (match)
    return {
      cid: match[1],
      screenName: 'Chat',
      goBackLink: `/case/${match[1]}`,
      assignClientLink: `/caseshare/${match[1]}/client`,
      assignLawyerLink: `/caseshare/${match[1]}/lawyer`,
      editPermissionsLink: `/caseshare/${match[1]}/collaborator`,
      archiveAction: startArchiveCase(match[1]),
      showEditMenu: true,
      showNotifications: false,
      hideSidebar: false,
    };
  match = casePath.exec(path);
  if (match)
    return {
      cid: match[1],
      screenName: 'Case',
      goBackLink: `/cases`,
      assignClientLink: `/caseshare/${match[1]}/client`,
      assignLawyerLink: `/caseshare/${match[1]}/lawyer`,
      editPermissionsLink: `/caseshare/${match[1]}/collaborator`,
      archiveAction: startArchiveCase(match[1]),
      showEditMenu: true,
      showNotifications: false,
      hideSidebar: false,
    };
  match = casePermissionsPath.exec(path);
  if (match)
    return {
      cid: match[1],
      screenName: permissionScreenName(match[2]),
      goBackLink: `/case/${match[1]}`,
      showEditMenu: false,
      showNotifications: false,
      hideSidebar: false,
    };
  match = setup.exec(path);
  if (match)
    return {
      screenName: 'Setup',
      goBackLink: `/setup`,
      showEditMenu: false,
      showNotifications: false,
      hideSidebar: true,
    };
  match = createFirm.exec(path);
  if (match)
    return {
      screenName: 'CreateFirm',
      goBackLink: `/setup`,
      showEditMenu: false,
      showNotifications: false,
      hideSidebar: true,
    };
  match = archivedCasesPath.exec(path);
  if (match)
    return {
      cid: match[1],
      screenName: 'Archived Case',
      goBackLink: `/cases/archived`,
      showEditMenu: true,
      showNotifications: false,
      unarchiveAction: startUnarchiveCase(match[1]),
      hideSidebar: false,
    };
  match = archivedCases.exec(path);
  if (match)
    return {
      screenName: 'Archived Cases',
      goBackLink: `/settings`,
      showEditMenu: false,
      showNotifications: true,
      hideSidebar: false,
    };
  match = cases.exec(path);
  if (match !== null)
    return {
      screenName: 'Cases',
      showEditMenu: false,
      showNotifications: true,
      hideSidebar: false,
    };
  match = threads.exec(path);
  if (match !== null)
    return {
      screenName: 'Chat',
      goBackLink: `/cases`,
      showEditMenu: false,
      showNotifications: true,
      hideSidebar: false,
    };
  match = explore.exec(path);
  if (match !== null)
    return {
      screenName: 'Explore',
      goBackLink: '/cases',
      showEditMenu: false,
      showNotifications: true,
      hideSidebar: false,
    };
  match = settings.exec(path);
  if (match !== null)
    return {
      screenName: 'Settings',
      goBackLink: '/cases',
      showEditMenu: false,
      showNotifications: true,
      hideSidebar: false,
    };
  match = profile.exec(path);
  if (match !== null)
    return {
      screenName: 'Profile',
      goBackLink: '/cases',
      showEditMenu: false,
      showNotifications: true,
      hideSidebar: false,
    };

  match = calendar.exec(path);
  if (match !== null)
    return {
      screenName: 'Calendar',
      showEditMenu: false,
      showNotifications: true,
      hideSidebar: false,
    };

  match = offers.exec(path);
  if (match !== null)
    return {
      screenName: 'Offers',
      showEditMenu: false,
      showNotifications: true,
      hideSidebar: false,
    };

  match = notifications.exec(path);
  if (match !== null)
    return {
      screenName: 'Notifications',
      goBackLink: '/cases',
      showEditMenu: true,
      showNotifications: false,
      hideSidebar: false,
    };
  return <Redirect from="/" to="/cases" />
}

export const initState = {
  loading: true,
  solicitationDialogOpen: false,
  fileUploadDialogOpen: false,
  notificationActionDialogOpen: false,
  header: { screenName: 'Legalese' },
  sidebar: {},
};

export default (state = initState, action) => {
  switch (action.type) {
    case 'NAVIGATION_LOADING':
      return {
        ...state,
        loading: true,
      };
    case 'NAVIGATION_LOADED':
      return {
        ...state,
        loading: false,
      };
    case 'NAVIGATION_OPEN_SOLICITATION_DIALOG':
      return {
        ...state,
        solicitationDialogOpen: true,
        warningText: action.warningText,
        onContinue: action.onContinue,
        onCancel: action.onCancel,
      };
    case 'NAVIGATION_CLOSE_SOLICITATION_DIALOG':
      return {
        ...state,
        solicitationDialogOpen: false,
      };
    case 'NAVIGATION_OPEN_NOTIFICATION_ACTION_DIALOG':
      return {
        ...state,
        notificationActionDialogOpen: true,
        warningText: action.warningText,
        onContinue: action.onContinue,
        onCancel: action.onCancel,
        onReject: action.onReject,
      };
    case 'NAVIGATION_CLOSE_NOTIFICATION_ACTION_DIALOG':
      return {
        ...state,
        notificationActionDialogOpen: false,
      };
    case 'NAVIGATION_OPEN_FILE_UPLOAD_DIALOG':
      return {
        ...state,
        fileUploadDialogOpen: true,
      };
    case 'NAVIGATION_CLOSE_FILE_UPLOAD_DIALOG':
      return {
        ...state,
        fileUploadDialogOpen: false,
      };
    case 'NAVIGATION_SET_HEADER':
      return {
        ...state,
        header: { ...state.header, ...action.data },
      };
    case LOCATION_CHANGE:
      const {
        screenName,
        editPermissionsLink,
        assignLawyerLink,
        assignClientLink,
        goBackLink,
        showEditMenu,
        showNotifications,
        archiveAction,
        unarchiveAction,
        hideSidebar,
      } = parsePath(action.payload.location.pathname);
      return {
        ...state,
        header: {
          ...state.header,
          screenName,
          editPermissionsLink,
          assignClientLink,
          assignLawyerLink,
          goBackLink,
          showEditMenu,
          showNotifications,
          archiveAction,
          unarchiveAction,
        },
        sidebar: {
          hideSidebar,
        },
      };
    default:
      return state;
  }
};
